import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { StartPurchaseOrForefitProperty } from "../../redux/action/sellerAction";
import { makeFullName } from "../../utils";
import SocketService from "../../Service/SocketService";
import useTranslationHook from "../hooks/useTranslationHook";
import { createPortal } from "react-dom";
import { fetchEmsignerStatus } from "../../redux/action/buyerAction";
import Shimmer from "./shimmer/Shimmer";
import { errToast } from "../../utils";
import { toast } from "react-toastify";
import EmsignerIframe from "./EmsignerIframe";

const StartBuyingProcessModal = ({
    show,
    onClose,
    isPurchased,
    setIsPurchased,
    setIsForeFitted,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { id: propertyId } = useParams();
    const { t } = useTranslationHook();

    const [isSubmiting, setIsSubmiting] = useState(false);
    const emsignerReturnedRef = useRef(false);
    const { account: isSeller } = useSelector((state) => state.profile);
    const { user_id, first_name, last_name } = useSelector((state) => state.auth.user) || {};

    useEffect(() => {
        document.body.classList.toggle("modal-open", show);
        if (show) {
            emsignerReturnedRef.current = false;
        }
        return () => {
            document.body.classList.remove("modal-open");
        };
    }, [show]);



    useEffect(() => {
        if (!show) return;
        const rawSearch = window.location.search;
        const normalized =
            rawSearch.slice(0, 1) + rawSearch.slice(1).replace(/\?/g, "&");
        const urlParams = new URLSearchParams(normalized);
        const workflowid = urlParams.get("workflowid");
        if (!workflowid) return;

        emsignerReturnedRef.current = true;

        urlParams.delete("workflowid");
        urlParams.delete("referenceno");
        const cleanSearch = urlParams.toString()
            ? `?${urlParams.toString()}`
            : "";
        navigate(
            { pathname: location.pathname, search: cleanSearch },
            { replace: true, state: location.state }
        );

        const runSubmit = async () => {
            if (!user_id || isSeller !== 0) {
                navigate("/sign-in");
                return;
            }
            setIsSubmiting(true);
            try {
                const verifyRes = await dispatch(
                    fetchEmsignerStatus(propertyId, "sale_purchase")
                );
                const status = verifyRes?.data?.user_sing_status;
                if (status === "completed" || status === "pending") {
                    const { data } = await dispatch(
                        StartPurchaseOrForefitProperty(propertyId)
                    );
                    if (!data?.error) {
                        setIsPurchased(true);
                        setIsForeFitted(false);
                        SocketService.send("getNotifications", { user_id });
                    }
                } else {
                    toast.info(
                        t(
                            "Agreement signing is pending. Please sign the agreement to proceed."
                        )
                    );
                }
            } catch (err) {
                errToast(err);
            } finally {
                setIsSubmiting(false);
            }
        };

        runSubmit();
        //eslint-disable-next-line
    }, [location.search, show]);

    return createPortal(
        <>
            {!isPurchased ? (
                <div
                    className={`modal fade ${show ? "show" : ""} purchase-modal`}
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-fullscreen modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header mb-0">
                                <h5 className="modal-title">
                                    {t("Purchase Agreement")}
                                </h5>

                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    onClick={onClose}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div>
                                <div className="modal-body">


                                    {isSubmiting ? (
                                        <Shimmer
                                            type="rectangle"
                                            width="100%"
                                            height="10vh"
                                            borderRadius="5%"
                                        />
                                    ) : (
                                        show && !emsignerReturnedRef.current && (
                                            <EmsignerIframe
                                                propertyId={propertyId}
                                                agreementType="sale_purchase"
                                            />
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    className={`modal fade ${show ? "show" : ""} purchase-modal`}
                    tabIndex="-1"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="text-center">
                                    <p>
                                        <img src="/img/check-L.svg" alt="" />
                                    </p>
                                    <h4>{t("Purchase Confirmed!")}</h4>
                                    <div className="mb-4">
                                        <p className="sky-text">
                                            {t("Your purchase agreement has been successfully submitted and processed.")}
                                        </p>
                                    </div>
                                </div>
                                <div className="sky-bg mb-4">
                                    <h6>{t("Confirmation Email Sent")}</h6>
                                    <p>
                                        {t("A receipt and payment instructions have been sent to your registered email address.")}
                                    </p>
                                </div>

                                <div className="sky-bg">
                                    <h6>{t("Next Steps:")}</h6>
                                    <div className="scroll">
                                        <ul>
                                            <li>
                                                {t("Complete payment within 5 business days")}
                                            </li>
                                            <li>
                                                {t("Arrange collection or shipping within 14 days")}
                                            </li>
                                            <li>
                                                {t("Check your email for detailed instructions")}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex">
                                <button
                                    className="btn btn-white btn-md btn-full"
                                    type="button"
                                    data-bs-dismiss="modal"
                                    onClick={onClose}
                                >
                                    {t("Close")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>,
        document.getElementById("root")
    );
};

export default StartBuyingProcessModal;
